// Logged-out marketing page at "/". Logged-in users see Home.tsx instead —
// see App.tsx's routing. Minimal one-pager: hero, a login CTA with an
// invite-only note (signup requires a pending box_invites row — see
// auth.go's signup — so "Get started" would be a lie; the honest action
// for a visitor is "Log in"), a 3-item pitch row, a privacy strip, and a
// small footer with legal links.
export function Landing() {
	return (
		<div class="flex-grow-1 overflow-auto">
			<div class="container px-3" style={{ maxWidth: "720px" }}>
				<div class="text-center pt-5 pb-4">
					<img
						src="/static/assets/logo.png"
						alt=""
						width="120"
						height="118"
						class="mb-2"
					/>
					<h1 class="brand-name mb-2">Artbox</h1>
					<p class="fs-5 mb-2">
						A private scrapbook for the art your kids make.
					</p>
					<p
						class="text-body-secondary mb-0 mx-auto"
						style={{ maxWidth: "34rem" }}
					>
						Snap a photo of each masterpiece, record the artist telling its
						story, and keep everything dated and boxed by kid, shared only with
						the family you invite.
					</p>
				</div>

				<div class="text-center pb-4">
					<a href="/login" class="btn btn-primary btn-lg px-5">
						Log in
					</a>
					<p class="small text-body-secondary mt-3 mb-0">
						<i class="bi bi-envelope-heart me-1" aria-hidden="true" />
						Artbox is invite-only: ask your family's box owner to send an invite
						to your email address. New here? Reach out to{" "}
						<a
							href="https://twitter.com/sharat87"
							target="_blank"
							rel="noopener noreferrer"
						>
							@sharat87
						</a>{" "}
						on Twitter for an invite.
					</p>
				</div>

				<div class="row row-cols-1 row-cols-sm-3 g-3 pb-4">
					<div class="col">
						<div class="card h-100 border-0 bg-body-tertiary text-center">
							<div class="card-body">
								<i
									class="bi bi-camera-fill fs-2 text-primary"
									aria-hidden="true"
								/>
								<h2 class="h6 mt-2 mb-1">Snap it</h2>
								<p class="small text-body-secondary mb-0">
									Photograph each piece the moment it comes off the kitchen
									table.
								</p>
							</div>
						</div>
					</div>
					<div class="col">
						<div class="card h-100 border-0 bg-body-tertiary text-center">
							<div class="card-body">
								<i
									class="bi bi-mic-fill fs-2 text-primary"
									aria-hidden="true"
								/>
								<h2 class="h6 mt-2 mb-1">Hear the story</h2>
								<p class="small text-body-secondary mb-0">
									Record the artist describing it in their own words, on audio
									or video.
								</p>
							</div>
						</div>
					</div>
					<div class="col">
						<div class="card h-100 border-0 bg-body-tertiary text-center">
							<div class="card-body">
								<i
									class="bi bi-people-fill fs-2 text-primary"
									aria-hidden="true"
								/>
								<h2 class="h6 mt-2 mb-1">Share with family</h2>
								<p class="small text-body-secondary mb-0">
									Invite grandparents to follow along. Viewers can look, but
									never edit.
								</p>
							</div>
						</div>
					</div>
				</div>

				<div class="text-center border-top pt-4">
					<p class="mb-1">
						<i
							class="bi bi-shield-lock-fill text-accent me-1"
							aria-hidden="true"
						/>
						<strong>Private by default.</strong>
					</p>
					<p class="small text-body-secondary mb-0">
						No public feeds, no ads, no data sharing. Only the people you invite
						ever see your kids' art.
					</p>
				</div>

				<footer class="text-center text-body-secondary small py-4">
					<div>© {new Date().getFullYear()} Artbox</div>
					<div class="mt-1">
						<a href="/terms" class="text-body-secondary me-3">
							Terms
						</a>
						<a href="/privacy" class="text-body-secondary">
							Privacy
						</a>
					</div>
				</footer>
			</div>
		</div>
	)
}
